import Skeleton from '@mui/material/Skeleton';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import type { RootState } from '@swf/core/store';

import { PKR_LOADERS } from '../../../../constants';
import { useHomeGamesWidget } from '../../../../model';
import ResultsHeader from '../ResultsHeader/ResultsHeader';
import ResultsTable from '../ResultsTable/ResultsTable';

import styles from './ResultsListItem.scss';

const ResultsListItem: React.FC = () => {
  const {
    params: { clubId, subsection }
  } = useRouteMatch<{ clubId: string; subsection: string }>();
  const [seasonId, tournId] = subsection.split('-');
  const { widgetSelect, widgetDispatch } = useHomeGamesWidget();
  const {
    playerTournamentResults: playerTournamentResultsLoading,
    clubSeasonSummaries: clubSeasonSummariesLoading
  } = useSelector(widgetSelect.loading);
  const results = useSelector(widgetSelect.playerTournamentResults);
  const summary = useSelector((rootState: RootState) =>
    widgetSelect.clubTournamentSummary(rootState, Number(tournId))
  );
  const loading = playerTournamentResultsLoading || clubSeasonSummariesLoading;

  useEffect(() => {
    if (!clubId || !seasonId || summary) return;

    widgetDispatch.fetchRecentTournamentSummaries({
      clubId: Number(clubId),
      seasonId: Number(seasonId)
    });
  }, [widgetDispatch, clubId, seasonId, summary]);

  useEffect(() => {
    if (summary && clubSeasonSummariesLoading) {
      widgetDispatch.setLoading({ isLoading: false, loaderName: PKR_LOADERS.clubSeasonSummaries });
    }
  }, [clubSeasonSummariesLoading, summary, widgetDispatch]);

  useEffect(() => {
    widgetDispatch.fetchPlayerTournamentResults({
      tournId: Number(tournId)
    });
  }, [widgetDispatch, tournId]);

  if (loading) {
    return (
      <>
        <ResultsHeader />
        <Skeleton className={styles.skeleton} variant="rectangular" height={200} width="100%" />
      </>
    );
  }

  return (
    <div>
      <ResultsHeader />
      {results && (
        <ResultsTable
          results={results}
          currency={summary?.currency as string}
          isPlayMoney={summary?.playMoney}
        />
      )}
    </div>
  );
};

export default ResultsListItem;
